import React, {useRef, useState} from "react"
import productPageImg from "../../../../assets/website-images/product/iam/iam-product-img.png"
import productBannerImg from "../../../../assets/website-images/product/product-banner.jpg";
import {useInView} from "framer-motion";
import PageBanner from "../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import "./services.scss"
import sec3Img from "../../../../assets/website-images/product/iam/sec3.png";
import sec3Img2 from "../../../../assets/website-images/services/s2.png";
import sec3Img3 from "../../../../assets/website-images/services/s3.png";
import sec3Img4 from "../../../../assets/website-images/services/s4.png";
import sec3Img5 from "../../../../assets/website-images/services/s5.png";
import sec3Img6 from "../../../../assets/website-images/services/s6.png";
import sec3Img7 from "../../../../assets/website-images/services/s7.png";
import {useTranslation} from "react-i18next";


export default function ServicesPage() {
    const {t} = useTranslation();
    const ref3 = useRef(null);
    const ref = useRef(null);
    const isInView3 = useInView(ref3, { once: true });
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const [activeSection, setActiveSection] = useState(1);
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };


    const handleSectionClick = (sectionIndex) => {
        setActiveSection(sectionIndex);
    };

    return(
        <div className={'services'}>
            <PageBanner img={productPageImg} heading={t('services.banner_head')} bannerImg={productBannerImg}/>
            <div className={'section-3'}>
                <Container>
                    <Row>
                        <Col lg={6} xl={7}>
                            <h2 className={'heading mb-4'}>{t('services.utrust_surveillance.head')}</h2>
                            <h3 className={'sub-heading-3'}>{t('services.utrust_surveillance.sub_head')}</h3>
                            <p>{t('services.utrust_surveillance.para_1')}</p>
                            <p>{t('services.utrust_surveillance.para_2')}</p>
                            <p>{t('services.utrust_surveillance.para_3')}</p>
                            <p>{t('services.utrust_surveillance.para_4')}</p>
                        </Col>
                        <Col lg={6} xl={5} className={'d-flex align-items-center justify-content-center'}>
                            <img src={sec3Img} className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-3'}>
                <Container>
                    <Row className={'flex-column-reverse flex-lg-row'}>
                        <Col lg={6} xl={5} className={'d-flex align-items-center justify-content-center'}>
                            <img src={sec3Img2} className={'img-fluid'}/>
                        </Col>
                        <Col lg={6} xl={7}>
                            <h2 className={'heading mb-4'}>{t('services.id_programs.head')}</h2>
                            <h3 className={'sub-heading-3'}>{t('services.id_programs.sub_head')}</h3>
                            <p>{t('services.id_programs.para_1')}</p>
                            <p>{t('services.id_programs.para_2')}</p>
                            <p>{t('services.id_programs.para_3')}</p>
                            <p>{t('services.id_programs.para_3')}</p>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-3'}>
                <Container>
                    <Row>
                        <Col lg={6} xl={7}>
                            <h2 className={'heading mb-4'}>{t('services.forensic_bio.head')}</h2>
                            <h3 className={'sub-heading-3'}>{t('services.forensic_bio.sub_head')}</h3>
                            <p>{t('services.forensic_bio.para_1')}</p>
                            <p>{t('services.forensic_bio.para_2')}</p>
                            <p>{t('services.forensic_bio.para_3')}</p>
                            <p>{t('services.forensic_bio.para_3')}</p>
                        </Col>
                        <Col lg={6} xl={5} className={'d-flex align-items-center justify-content-center'}>
                            <img src={sec3Img3} className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-3'}>
                <Container>
                    <Row className={'flex-column-reverse flex-lg-row'}>
                        <Col lg={6} xl={5} className={'d-flex align-items-center justify-content-center'}>
                            <img src={sec3Img4} className={'img-fluid'}/>
                        </Col>
                        <Col lg={6} xl={7}>
                            <h2 className={'heading mb-4'}>{t('services.biometric_sdk.head')}</h2>
                            <h3 className={'sub-heading-3'}>{t('services.biometric_sdk.sub_head')}</h3>
                            <p>{t('services.biometric_sdk.para_1')}</p>
                            <p>{t('services.biometric_sdk.para_2')}</p>
                            <p>{t('services.biometric_sdk.para_3')}</p>

                        </Col>
                    </Row>
                </Container>
            </div>


            <div className={'section-3'}>
                <Container>
                    <Row>
                        <Col lg={6} xl={7}>
                            <h2 className={'heading mb-4'}>{t('services.biometric_driven.head')}</h2>
                            <h3 className={'sub-heading-3'}>{t('services.biometric_driven.sub_head')}</h3>
                            <p>{t('services.biometric_driven.para_1')}</p>
                            <p>{t('services.biometric_driven.para_2')}</p>
                            <p>{t('services.biometric_driven.para_3')}</p>
                            <p>{t('services.biometric_driven.para_4')}</p>
                        </Col>
                        <Col lg={6} xl={5} className={'d-flex align-items-center justify-content-center'}>
                            <img src={sec3Img5} className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-3'}>
                <Container>
                    <Row className={'flex-column-reverse flex-lg-row'}>
                        <Col lg={6} xl={5} className={'d-flex align-items-center justify-content-center'}>
                            <img src={sec3Img6} className={'img-fluid'}/>
                        </Col>
                        <Col lg={6} xl={7}>
                            <h2 className={'heading mb-4'}>{t('services.custom_iam.head')}</h2>
                            <h3 className={'sub-heading-3'}>{t('services.custom_iam.sub_head')}</h3>
                            <p>{t('services.custom_iam.para_1')}</p>
                            <p>{t('services.custom_iam.para_2')}</p>
                            <p>{t('services.custom_iam.para_3')}</p>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-3'}>
                <Container>
                    <Row>
                        <Col lg={6} xl={7}>
                            <h2 className={'heading mb-4'}>{t('services.on_premise.head')}</h2>
                            <h3 className={'sub-heading-3'}>{t('services.on_premise.sub_head')}</h3>
                            <p>{t('services.on_premise.para_1')}</p>
                            <p>{t('services.on_premise.para_2')}</p>
                            <p>{t('services.on_premise.para_3')}</p>
                        </Col>
                        <Col lg={6} xl={5} className={'d-flex align-items-center justify-content-center'}>
                            <img src={sec3Img7} className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </div>



        </div>
    )
}